/**
 * 资源加载失败采集：只关心 JS / CSS
 *
 * chunk 加载失败是「发版后老页面请求旧文件」的典型症状，会直接白屏，优先级最高。
 */
import { track } from '@/monitor/core/aggregator';

export const setupResourceCollector = (): void => {
  /** 资源错误不冒泡，必须在捕获阶段监听 */
  window.addEventListener(
    'error',
    (event: Event) => {
      const target = event.target;
      /**
       * 只收脚本和样式表。图片失败不上报 —— 用户上传素材失效是业务常态，
       * 报了全是噪音。
       */
      const isScript = target instanceof HTMLScriptElement;
      const isStyle = target instanceof HTMLLinkElement;
      if (!isScript && !isStyle) return;
      const url = isScript ? target.src : target.href;
      if (!url) return;
      track({
        type: 'resource_error',
        level: 'error',
        title: '资源加载失败',
        message: `${isScript ? 'script' : 'stylesheet'} 加载失败`,
        source: url,
        extra: { 提示: '常见于发版后老页面请求旧 chunk' },
        timestamp: Date.now(),
      });
    },
    true,
  );
};
